import styles from './WebinarDocs.module.scss';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';

const WebinarDocs = ({ props }) => {
  return (
    <section className={classnames(isMobile ? [styles.section, styles.mobile] : [styles.section])}>
      <h2 className={classnames(isMobile ? [styles.sectionTitle, styles.mobile] : [styles.sectionTitle])}>Материалы</h2>

      <ul className={styles.list}>
        {props.map((item) => {
          return (
            <li key={item.id} className={styles.item}>
              <a
                href={item.filename}
                className={classnames(isMobile ? [styles.link, styles.mobile] : [styles.link])}
                target="_blank"
                rel="noreferrer">
                {item.title}
              </a>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default WebinarDocs;
